import { useState } from "react";
import { tx } from "@/i18n";

// Prikbordtekst; bij een automatische vertaling klein "Vertaald · Toon origineel".
export const NoticeText = ({ n, className, testId }) => {
  const [orig, setOrig] = useState(false);
  const translated = !!n.text_original;
  const toggle = (e) => { e.stopPropagation(); e.preventDefault(); setOrig((v) => !v); };
  return (
    <>
      <p className={className} data-testid={testId}>{translated && orig ? n.text_original : n.text}</p>
      {translated && (
        <span className="block mt-1 text-[11px] text-muted-foreground">
          {tx("Vertaald")} ·{" "}
          <span role="button" tabIndex={0} onClick={toggle} onKeyDown={(e) => e.key === "Enter" && toggle(e)}
            className="underline underline-offset-2 hover:text-foreground cursor-pointer" data-testid={`notice-original-toggle-${n.id}`}>
            {orig ? tx("Toon vertaling") : tx("Toon origineel")}
          </span>
        </span>
      )}
    </>
  );
};
